module.exports = __webpack_public_path__ + "img/67ne.f9dd8627.svg";